import { httpService } from "./httpService";
import { ImportsModalCtx } from "../components/imports/ImportsModalCtx";

export const importService = {
    getBusinesses(platform: string, formData: object) {
        return httpService.postRequest<any, any>(`imports/platform${platform}/businesses`, formData)
    },

    async getFeed(platform: string, formData: object) {
        let getFeedResp = await httpService.postRequest<any, any>(`imports/platform${platform}`, formData);
        if (getFeedResp.data && getFeedResp.data.error) {
            getFeedResp.data.error = ImportsModalCtx.errorMessage;
        }
        return getFeedResp;
    },

    importFeed(platform: string, formData: object) {
        return httpService.postRequest<any, any>(`imports/platform${platform}/store`, formData)
    },

    manualImportRequest(formData: FormData) {
        return httpService.postFormDataRequest("imports/new-request", formData);
    },
}